export default __webpack_public_path__ + "static/media/lightswitch_single_1.91085ea1.svg";